export const COIN_TYPES = {
  coins: 'coins',
  apology_coins: 'apology_coins',
  reward_coins: 'reward_coins',
  coins_pack: 'coins_pack',
}

export const COIN_TYPE_LABELS = {
  coins: 'Coins',
  apology_coins: 'Apology Coins',
  reward_coins: 'Reward Coins',
  coins_pack: 'Coins Pack',
}
